import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forEach } from 'lodash';

import { EmployeeStatusesService } from '../../employee-statuses.service';
import { Enums } from '../../../../../../../configs/Enums';
import { AuthService } from '../../../../../../auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-employee-status-change-modal',
  templateUrl: './employee-status-change-modal.component.html',
  styleUrls: ['./employee-status-change-modal.component.scss'],
  standalone: false,
})
export class EmployeeStatusChangeModalComponent implements OnInit {
  moment = require('moment');
  changeEmployeeStatusLoading = false;
  currentSectorTime;
  statusTypeDate = {
    initDate: null,
    options: null,
    dateObj: null,
    date: null,
    isNewStatusDateInvalid: false,
  };
  status: number;
  employee;
  sectorId: number | string;
  statuses;
  statusesFiltered;
  statusSelected;
  errorMessage: string;
  methodSelected = 'step';
  isCommentShow = false;
  commentary = '';
  ticketStatusWarning: string;
  dataLoading: boolean;
  changeStatusLoading: boolean;
  changeStatusDataError: string;
  changeStatusError: string;
  isBlockedChangeStatus: boolean;
  public dateShortFormat = Enums.dates.shortFormat;
  public dateFullFormat = Enums.dates.fullFormat;

  constructor(
    private employeeStatusesService: EmployeeStatusesService,
    public activeModal: NgbActiveModal,
    private authService: AuthService
  ) {}

  get isGRS() {
    return this.authService.isGRSUser();
  }

  ngOnInit() {
    this.getStatuses();
    this.isBlockedChangeStatus = !this.authService.checkPermission('schedule_worklog.change.status');

    if (this.isBlockedChangeStatus) {
      this.errorMessage = Enums.errorCodes[200000];
    }
  }

  onChangeEmployeeStatus() {
    this.changeStatusLoading = true;
    const params = {
      int_begin: this.moment(this.statusTypeDate.dateObj.dateMillis).format(this.dateFullFormat),
      transport: this.methodSelected === 'auto' ? 1 : 0,
      commentary: this.commentary || null,
      user: this.employee.u_id,
      status: this.statusSelected.sws_id,
    }

    if (this.isGRS) {
      params['sector_id'] = +this.sectorId;
    }

    this.employeeStatusesService
      .changeEmployeeStatus(params)
      .subscribe(
        (response) => {
          this.activeModal.close();
          this.changeStatusLoading = false;
        },
        (error) => {
          if (error.error.metadata.code === 100030) {
            this.changeStatusError = 'Введенные данные неактуальны. ' +
              'Обновите страницу заявки, чтобы загрузить информацию о последнем статусе.';
          } else {
            this.changeStatusError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
          }
          this.changeStatusLoading = false;
        }
      );
  }

  getStatuses() {
    this.dataLoading = true;
    this.employeeStatusesService.getChangeStatusDataUnion({ sector_id: this.sectorId }).subscribe(
      (response) => {
        this.statuses = response[0]['data'];
        this.currentSectorTime = response[1]['data'].current_time;
        this.makeStatuses();
        this.setDate();
        this.setComment();
        this.dataLoading = false;
      },
      (error) => {
        this.statuses = null;
        this.dataLoading = false;
        this.changeStatusDataError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
      }
    );
  }

  setComment() {
    this.commentary = (this.employee.worklog && this.employee.worklog.commentary) || '';
    this.isCommentShow = Boolean(this.commentary);
  }

  makeStatuses() {
    this.status = (this.employee.worklog && this.employee.worklog.status) || 3;
    let statusesMap = {};
    statusesMap[1] = [2, 3];
    statusesMap[2] = [1];
    statusesMap[3] = [1];

    this.statusesFiltered = [];

    forEach(this.statuses, (s) => {
      if (statusesMap[this.status].indexOf(s.sws_id) > -1) {
        this.statusesFiltered.push(s);
      }
    });

    this.statusSelected = this.statusesFiltered && this.statusesFiltered.length ? this.statusesFiltered[0] : null;
  }

  setDate() {
    let lastStatusDate = (this.employee.worklog && this.employee.worklog.int_date) || new Date('1970-01-01T00:00:00');

    this.statusTypeDate.initDate = this.moment(this.currentSectorTime)._d;
    setTimeout(() => {
      this.statusTypeDate.options = {
        minDate: this.moment(lastStatusDate).startOf('day')._d,
        maxDate: this.moment(new Date()).endOf('day')._d,
      };
    }, 4);
  }

  onChangeEmployeeStatusType(status) {
    this.statusSelected = status;
  }

  onMethodTypeChanged(method) {
    this.methodSelected = method;
  }

  onChangeCommentVisible() {
    this.isCommentShow = true;
  }

  onCommentChange(event) {
    this.commentary = event.target.value;
  }

  onChangeStatusDate(dateObj) {
    let lastStatusDate = (this.employee.worklog && this.employee.worklog.int_begin) || new Date('1970-01-01T00:00:00');
    this.statusTypeDate.dateObj = dateObj;

    if (dateObj.dateMillis) {
      let a = +new Date(lastStatusDate);
      let b = +new Date(dateObj.dateMillis);
      let c = +this.moment(this.currentSectorTime);

      if (b >= a && b <= c) {
        this.statusTypeDate.isNewStatusDateInvalid = true;
      } else {
        this.statusTypeDate.isNewStatusDateInvalid = false;

        if (b < a) {
          this.ticketStatusWarning =
            'Время не может быть ранее времени последнего статуса сотрудника' +
            ' (' + this.moment(lastStatusDate).add(1, 'minute').format('DD.MM.YYYY HH:mm') + ')';
        }

        if (b > a && b > c) {
          this.ticketStatusWarning = 'Время не может быть позже текущего времени.';
        }
      }
    }
  }
}
